import React, { useState } from "react";
import { Formik, FormReg, FormRegEmail } from "components/form";
import { apiReg, apiRegEmail } from "app/api";
import { schemas, values } from "app/utils/schemas";
import { useNavigate } from "react-router-dom";
import { action, useDsp } from "app/store";
import ButtonText from "elements/button/ButtonText/ButtonText";
// import { info } from "app/constants/messages";

export const WrapperReg = () => {
  const navigate = useNavigate();
  const dispatch = useDsp();

  const [regStep, setRegStep] = useState(1);

  // API EMAIL
  const apiEmailSuccess = ({ status }: any, email: string) => {
    // console.log("API REG SUCCESS");
    if (status === 201) {
      setRegStep(2);
      dispatch(action.activatedEmailSet(email));
      localStorage.setItem("temporaryemail", email);
    }
  };
  const apiEmailError = (err: any) => {
    // console.log("API REG ERROR", err);
  };

  // API REG
  const apiSuccess = ({ status }: any) => {
    // console.log("API REG SUCCESS");
    if (status === 201) {
      navigate("/sign-in");
      // dispatch(
      //   action.mInfoSetData({
      //     title: info.reg.title,
      //     message: info.reg.message,
      //   })
      // );
      // console.log("ACT EMAIL", email);
      // dispatch(action.mInfoShow());
      // dispatch(action.authVariantSet("activate"));
      // dispatch(action.activationIsShowSet(false));
      // dispatch(action.activatedResendSet(false));
    }
  };
  const apiError = (err: any) => {
    // console.log("API REG ERROR", err);
  };

  return (
    <>
      {regStep === 1 && (
        <Formik
          initialValues={values.regEmail}
          validationSchema={schemas.regEmail}
          onSubmit={(params, { setErrors }) => {
            apiRegEmail(
              params,
              (data: any) => apiEmailSuccess(data, params.email),
              apiEmailError,
              setErrors
            );
          }}
        >
          <FormRegEmail />
        </Formik>
      )}

      {regStep === 2 && (
        <>
          <ButtonText
            className="mt-3"
            size="md"
            onClick={() => {
              setRegStep(1);
            }}
          >
            &lt; Назад
          </ButtonText>

          <Formik
            initialValues={values.regis}
            validationSchema={schemas.regis}
            onSubmit={(params, { setErrors }) => {
              apiReg(
                params,
                (data: any) => apiSuccess(data),
                apiError,
                setErrors
              );
            }}
          >
            <FormReg />
          </Formik>
        </>
      )}
    </>
  );
};
